import React from 'react';

export default function Logout() {
    localStorage.removeItem('trc-client-token');
    window.location.href="/";

    return(
        <h2>Déconnexion</h2>
    );
}